"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
/** Only Renders the children of the object if the Condition is met. */
exports.JSXIf = (props) => (!!props.Condition) ? props.children : null;
/** For use with JSXSwitch statement.  */
exports.JSXCase = (props) => {
    const { Default } = props, jsxIfProps = __rest(props, ["Default"]);
    return (!!props.Default) ? props.children : (React.createElement(exports.JSXIf, Object.assign({}, jsxIfProps)));
};
/**
 * This is a switch statement for JSXIf components.  The first that evaulates to true is built.
 * All others are ignored.
 *
 * Example of use:
 * <JSXSwitch>
 *    <JSXCase Condition={false}>
 *        //I will not render cause I am false.
 *    </JSXCase>
 *    <JSXCase Condition={true}>
 *        //I will render cause I am the first true.
 *    </JSXCase>
 *    <JSXCase Condition={true}>
 *        //I will not render cause I am not the first true.
 *    </JSXCase>
 *    <JSXCase Default>
 *        //I will render by default if no previous condition is true.
 *    </JSXCase>
 * </JSXSWITCH>
 */
exports.JSXSwitch = (props) => {
    let matchingElementFound = false;
    let matchingElement = null;
    React.Children.forEach(props.children, function (element) {
        // Can't yet specify children to be a specific type other than JSX.Element.  When we can do
        // that then this runtime check is no longer necessary.
        if (element.type !== exports.JSXCase) {
            throw new Error('JSXSwitch only accepts child elements of type JSXSwitch');
        }
        const jsxIfProps = element.props;
        if (!matchingElementFound && (jsxIfProps.Default || jsxIfProps.Condition)) {
            matchingElementFound = true;
            matchingElement = element;
        }
    });
    if (!matchingElementFound) {
        return null;
    }
    return matchingElement;
};
//# sourceMappingURL=JSXConditions.js.map